export function isIOS() {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";

  // iPhone, iPod, or legacy iPad user agent
  if (/iPad|iPhone|iPod/i.test(ua)) return true;

  // Client hints (Safari / Chrome on iOS)
  if (navigator.userAgentData?.platform === "iOS") return true;

  // Native iOS WebView
  if (typeof window !== "undefined" && Boolean(window.webkit?.messageHandlers)) {
    return true;
  }

  const isMacLike = platform === "MacIntel" || /Macintosh|Mac OS X/i.test(ua);

  // iPadOS 13+ Safari: reports as Mac with multi-touch
  if (isMacLike && navigator.maxTouchPoints > 1) return true;

  // iPadOS desktop-class UA + touch device (real iPad + Chrome DevTools iPad emulation)
  if (
    typeof window !== "undefined" &&
    isMacLike &&
    window.matchMedia("(hover: none) and (pointer: coarse)").matches
  ) {
    return true;
  }

  return false;
}

/** True when running inside the TrackYourWheelz iOS app WebView (not Mobile Safari). */
export function isNativeIOSApp() {
  if (typeof window === "undefined") return false;
  if (window.webkit?.messageHandlers) return true;
  if (window.Capacitor?.isNativePlatform?.()) return true;
  if (window.cordova || window.ReactNativeWebView) return true;
  return false;
}

/**
 * Block file/camera picker on iOS — App Store WebView crashes without NSCameraUsageDescription.
 * Re-enable after native Info.plist is updated (build 3+).
 */
export function shouldDisableCameraFileInput() {
  return isIOS();
}

/** Block external payments on iOS — App Store guideline 3.1.1 (In-App Purchase). */
export function shouldHideSubscriptionPurchase() {
  if (process.env.REACT_APP_HIDE_SUBSCRIPTION_PURCHASE === "true") {
    return true;
  }
  return isIOS();
}

/** Paths that must not render payment / subscription UI on iOS (App Store review). */
export const IOS_BLOCKED_PAYMENT_PATHS = [
  "/payment",
  "/customer/subscription",
  "/admin/subscription-plans",
];

export function isIosBlockedPaymentPath(pathname = "") {
  if (!pathname) return false;
  const path = pathname.split("?")[0].replace(/\/+$/, "") || "/";
  return IOS_BLOCKED_PAYMENT_PATHS.some(
    (blocked) => path === blocked || path.startsWith(`${blocked}/`)
  );
}

export function getIosPaymentSafeRoute(user) {
  if (user?.role === "customer" || user?.role === "user") {
    return "/customer/dashboard";
  }
  if (
    user?.role === "admin" ||
    user?.role === "super_admin" ||
    user?.role === "superadmin"
  ) {
    return "/admin/dashboard";
  }
  return "/home";
}

export function isRestorableRouteOnPlatform(route, user) {
  if (!route || !user) return false;
  if (shouldHideSubscriptionPurchase() && isIosBlockedPaymentPath(route)) {
    return false;
  }
  return true;
}
